/*
 * Generated by graphql-codegen. Do not modify this file manually.
 */

// @ts-ignore Allow unused imports
import type * as Types from '../../../../graphql/schema';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type FirmBillableAccountsCsvExportQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type FirmBillableAccountsCsvExportQuery = { __typename: 'Query', firmBillableAccountsCsvExport: { __typename: 'CsvExport', status: Types.CsvExportStatus, id: string } | null };


export const FirmBillableAccountsCsvExportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FirmBillableAccountsCsvExport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firmBillableAccountsCsvExport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<FirmBillableAccountsCsvExportQuery, FirmBillableAccountsCsvExportQueryVariables>;